// this function detects most providers injected at window.ethereum
import detectEthereumProvider from '@metamask/detect-provider';
import Web3 from 'web3';

export default new Promise((resolve, reject) => {
    
    detectEthereumProvider()
    .then(provider => {
        if (provider) {
            provider.autoRefreshOnNetworkChange = false;
            resolve(new Web3(provider));
          } else {
            reject('Please install MetaMask!');
          }
    });

});